<template>
  <div
    :class="[
      'search-area',
      {
        'search-area--on-top': isNavbarHidden,
      },
    ]"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { DKButton } from '@dormakaba/dormakaba-components';

@Component({
  components: {
    DKButton,
  },
})
export default class DKSearchArea extends Vue {
  get isNavbarHidden() {
    return this.$store.getters['navigation/isNavbarHidden'];
  }
}
</script>

<style lang="postcss" scoped>
.fade-enter-active .search-area,
.fade-leave-active .search-area {
  @apply relative top-0;
}

.search-area {
  @apply sticky;
  @apply z-30;
  @apply top-main-navbar;
  @apply transition-all delay-100 duration-300 ease-linear;

  &.search-area--on-top {
    @apply top-0;
  }
}
</style>
